export const enum FormFieldTypeEnum {
  SELECT = 'select',
  PASSWORD = 'password',
  INPUT = 'input',
  TEXT_AREA = 'textArea',
  ATTACHMENT = 'attachment',
  FILE= 'file',
  DATE = 'date',
  DATE_TIME = 'dateTime',
  TITLE = 'title',
  LABEL ='label',
  EMAIL = 'email',
  TELEPHONE = 'telephone',
  NUMBER = 'number',
  SWITCH = 'switch',
  OPTION = 'option'
}
